import { useHistory } from 'react-router-dom';

const DocumentManagementSideMenuBuilder = (accountId) => {
  const history = useHistory();

  const buildListDocumentsTab = () => {
    return {
      label: "List Documents",
      icon: 'pi pi-list',
      command: () => {
        const url = `/accounts/${accountId}/documents`;
        history.push(url);
      },
    };
  };

  const buildCreateDocumentsTab = () => {
    return {
      label: "Create Documents",
      icon: 'pi pi-plus',
      command: () => {
        const url = `/accounts/${accountId}/documents/create`;
        history.push(url);
      },
    };

  };

  const buildDocumentManagementMenu = () => {
    const listDocumentsContent = buildListDocumentsTab();
    const createDocumentsContent = buildCreateDocumentsTab();


    const documentManagement = {
      label: "Document Management",
      icon: 'pi pi-cog',
      items: [listDocumentsContent, createDocumentsContent],
    };

    return documentManagement;
  };

  return {
    buildDocumentManagementMenu,
  };
};

export default DocumentManagementSideMenuBuilder;
